import { render } from "./AddEditWhatsAppTemplateSettings.vue?vue&type=template&id=30af353f"
import script from "./AddEditWhatsAppTemplateSettings.vue?vue&type=script&lang=js"
export * from "./AddEditWhatsAppTemplateSettings.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__